export default __webpack_public_path__ + "5956ef1063bc42e93c718bd189996fc0.jpg";